import {of, forkJoin} from 'rxjs';
import {concatMap, catchError} from 'rxjs/operators';
import {ofType} from 'redux-observable';
import Http from '../../http/http';
import AppSettings from '../../app.settings';

import * as Attributes from './attributes.action';
import {ASSET_TYPE_ATTRIBUTE} from '../../api/assetTypeAttribute';

const extract = response => response.data;

const attrSources = [
  Http.get(AppSettings.IcebergApiAttributesEndpoint + '/attrs').pipe(
    catchError(error => of(Attributes.fetchFailure(error)))
  ),
  Http.get(`${AppSettings.BaseTugApiUrl}/config/attribute/security`).pipe(
    catchError(error => of(Attributes.fetchSecurityFailure(error)))
  )
];

function titleCase(str) {
  if (!str) return '';

  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.replace(word[0], word[0].toUpperCase()))
    .join(' ');
}

const toFullAttribute = readonlyAttr => ({
  key: titleCase(readonlyAttr),
  dataType: 'Text',
  freeform: true,
  id: readonlyAttr.toUpperCase(), // downstream components access this directly, breaks ngRepeat if not unique
  range: {} // downstream components access this directly :(
});

export const fetch = action$ =>
  action$.pipe(
    ofType(Attributes.FETCH_ATTRIBUTES_BEGIN, Attributes.ATTRIBUTE_CREATED, Attributes.ATTRIBUTE_REMOVED),
    concatMap(() => forkJoin(attrSources)), // any of the above will kick off re-retrieve of attrs and attr security
    concatMap(([attributeResponse, attributeSecurity]) => {
      let attributes = extract(attributeResponse);

      // Yank out readonly attributes
      const readonly = Object.keys(attributeSecurity)
        .filter(key => attributeSecurity.hasOwnProperty(key))
        .filter(key => Array.isArray(attributeSecurity[key]) && attributeSecurity[key].indexOf('readonly') !== -1)
        .map(key => key.toLowerCase());

      const attrSecurityRules = {
        readonly
      };

      const readonlyAsAttrs = readonly.map(toFullAttribute);
      // Put readonly attributes into collection if they are not already present in existing attribute definitions
      attributes = attributes.concat(readonlyAsAttrs.filter(item => attributes.indexOf(item) === -1));

      // Add asset type attribute
      //attributes = attributes.concat(ASSET_TYPE_ATTRIBUTE);

      return of(Attributes.fetchSuccess(attributes), Attributes.fetchSecuritySuccess(attrSecurityRules));
    })
  );
